"use strict";

module.exports = function getType(data) {
  return Object.prototype.toString.call(data).replace(/\[object /gi, "").replace(/\]/gi, "");
};